import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { APP_CONSTANTS } from 'src/constants/constants';
import { AVAILABLE_LANGUAGES } from 'src/services/translate/languagesData';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss'],
})
export class LanguagePickerComponent implements OnInit {
  @Input() selectedId: string;

  languageSet: ILangSetPayload = {};

  currentLangId: string;

  constructor(
    private modalCtrl: ModalController,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.currentLangId = this.selectedId || this.translateService.currentLang;

    this.translateService.getLangs().forEach((key) => {
      this.languageSet[key] = {
        ...AVAILABLE_LANGUAGES[key],
        selected: this.currentLangId === key,
      };
    });
  }

  closeView() {
    this.modalCtrl.dismiss();
  }

  selectLanguage(id: string) {
    this.modalCtrl.dismiss(id);
  }
}

export interface ILangSetPayload {
  [key: string]: {
    name: string;
    translations: { [key: string]: string };
    selected: boolean;
  };
}
